<template>
	<van-tabbar
			v-model="active"
			route
			placeholder>
		<van-tabbar-item
				v-for="(item,index) in tabBarList"
				:key="index"
				:badge="item.badge"
				:to="item.url">
			<span>{{ item.name }}</span>
      <template #icon="props">
        <img :src="props.active ? item.icon.active : item.icon.inactive" />
      </template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
import {defineComponent, computed, ref, watch} from "vue";
import store from '@/store';

export default defineComponent({
	name: "TabBar",
	props: {
		active: {
			type: Number,
			default: 0
		},
	},
	setup(props) {
		const active = ref(props.active);
		// 购物车数量
		const cartNum = computed(() => {
			return store.state.reader.cartNum;
		});
		const tabBarList = ref([]);
		tabBarList.value = [
			{
				name: '首页',
				url: '/index',
        icon: {
          active: require('@/assets/img/icon-active-shouye.png'),
          inactive: require('@/assets/img/icon-inactive-shouye.png'),
        },
			},
      {
				name: '书目分类',
				url: '/catalog',
        icon: {
          active: require('@/assets/img/icon-active-fenlei.png'),
          inactive: require('@/assets/img/icon-inactive-fenlei.png'),
        },
			},
      {
				name: '购物车',
				url: '/shopcart',
        icon: {
          active: require('@/assets/img/icon-active-gouwuche.png'),
          inactive: require('@/assets/img/icon-inactive-gouwuche.png'),
        },
			}, {
				name: '个人中心',
				url: '/personalCenter',
        icon: {
          active: require('@/assets/img/icon-active-gerenzhongxin.png'),
          inactive: require('@/assets/img/icon-inactive-gerenzhongxin.png'),
        },
			}
		];
		watch(
				cartNum, () => {
					Object.assign(tabBarList.value[2], {badge: cartNum.value});
				},
				{immediate: true}
		);
		return {
			active,
			tabBarList,
			cartNum,
		}
	},
});
</script>

<style scoped lang="less">
@import "../../assets/css/tabbar.less";
</style>
